import {
  messageIdQueryParamKey,
  messagingSections,
} from '@/modules/messaging/constants';

interface GetMessageLinkParams {
  threadId?: string | undefined | null;
  messageId?: string | undefined | null;
  hasSentMessages: boolean | undefined;
}

export const getMessageLink = ({
  threadId,
  messageId,
  hasSentMessages,
}: GetMessageLinkParams) => {
  const section = hasSentMessages
    ? messagingSections.conversations
    : messagingSections.drafts;
  const baseLink = '/messaging';

  const searchParams = new URLSearchParams();
  searchParams.set('tab', section);

  const entityId =
    section === messagingSections.conversations ? threadId : messageId;
  if (entityId) {
    searchParams.set(messageIdQueryParamKey[section], entityId);
  }

  const queryString = searchParams.toString();
  return queryString ? `${baseLink}?${queryString}` : baseLink;
};
